import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../axiosConfig";
import { LocationData } from "../../types";

export interface LocationOffering {
  locationId: string;
  offeringId: string;
}

export interface LocationsState {
  byId: Record<string, LocationData>;
  allIds: string[];
  loading: boolean;
  error: string | null;
}

export type LocationMap = Record<string, LocationData>;

const initialState: LocationsState = {
  byId: {},
  allIds: [],
  loading: false,
  error: null,
};

// Async thunks
export const fetchLocations = createAsyncThunk(
  "locations/fetchLocations",
  async () => {
    const response = await axios.get("/api/locations");
    return response.data;
  }
);

const locationsSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Locations
      .addCase(fetchLocations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchLocations.fulfilled,
        (state, action: PayloadAction<LocationData[]>) => {
          state.loading = false;
          state.byId = {};
          state.allIds = [];

          action.payload.forEach((location) => {
            state.byId[location.id] = location;
            state.allIds.push(location.id);
          });
        }
      )
      .addCase(fetchLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch locations";
      });
  },
});

export default locationsSlice.reducer;
